export default [
    {
        title: "Map",
        route: "Map",
        icon: "HomeIcon",
        resource: "Admin",
        action: "read",
    },
]